import { useMoveToWebview } from './moveToWebview';
import { moveToToday } from './moveToToday';
import { moveToSearch } from './moveToSearch';
import { useMoveToScreens } from './moveToScreens';
import { useMoveToHome } from './moveToHome';
import { useMoveToLikeFolders } from './moveToLikeFolders';
import { moveToRoot } from './moveToRoot';
import { useMoveToCategoryTab } from './moveToCategoryTab';
import { useMoveToCategory } from './moveToCategory';
import { useMoveToSetting } from './moveToSetting/moveToSetting';
import { useMoveToNotification } from './moveToNotification/moveToNotification';

export const useCommonNavigator = () => {
  const moveToWebview = useMoveToWebview();
  const moveToScreens = useMoveToScreens();
  const moveToHome = useMoveToHome();
  const moveToLikeFolders = useMoveToLikeFolders();
  const moveToCategoryTab = useMoveToCategoryTab();
  const moveToCategory = useMoveToCategory();
  const moveToSetting = useMoveToSetting();
  const moveToNotification = useMoveToNotification();

  return {
    moveToRoot,
    moveToWebview,
    moveToToday,
    moveToSearch,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
    moveToCategoryTab,
    moveToCategory,
    moveToSetting,
    moveToNotification,
  };
};
